export default __webpack_public_path__ + "static/media/kebab.12cf2af2.svg";